import { Button, Input, Modal, Radio, Select, Space, Tag, message } from 'antd'
import React from 'react'
import { TagWrap } from './styles'
import { Text, View } from '../../../../styles/reactnative'
import { COLORS } from '../../../constants'
import API from '../../../../utils/api'
import { useToken } from '../../../hooks'
import WalletTag from '../../WalletTag'
import { useFetcher } from '../../../hooks/fetcher'

const Column_walletlist_action = ({ record, mutate }) => {
	const [visible, setVisible] = React.useState(false)
	const [wallet_type, setWallet_type] = React.useState(record?.wallet_type)
	const [deposit_withdraw, setDeposit_withdraw] = React.useState(1)
	const [amount, setAmount] = React.useState('')
	const [count, setCount] = React.useState(0)
	const [text, setText] = React.useState('')
	const [selected, setSelected] = React.useState('')
	const { data: token } = useToken()

	const onDeposit = id => {}

	const { data, refresh } = useFetcher('/admin/cashmemo', false)
	console.log(data)

	const saveMemo = () => {
		API.post('/admin/cashmemo', token + '', {
			memo: text,
		})
			.then(res => {
				if (res.result.success) {
					message.success('성공')
					refresh()
				} else {
					message.error(res.result.message)
				}
			})
			.catch(err => {
				message.error(err.message)
			})
	}


	const formatNumber = value => {
		return value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
	  };
	
	const handleAmountChange = e => {
		const value = e.target.value.replace(/,/g, '');
		if (!isNaN(value)) {
			setAmount(formatNumber(value));
		}
	};


	return (
		<TagWrap>
			<Modal
				zIndex={1001}
				open={visible}
				okText="확인"
				cancelText="취소"
				onCancel={() => {
					setVisible(false)
				}}
				onOk={() => {
					const numericAmount = parseInt(amount.replace(/,/g, ''), 10);
					API.post('/admin/wallet/manual', token + '', {
						id: record?.id,
						deposit_withdraw: deposit_withdraw,
						amount: numericAmount,
						lockcount: count,
						memo: text,
					})
						.then(res => {
							if (res.result.success) {
								message.success('성공')
								mutate()
							} else {
								message.error(res.result.message)
							}
						})
						.catch(err => {
							message.error(err.message)
						})
						.finally(() => {
							setVisible(false)
						})
				}}>
				<View>
					<Text>
						<WalletTag
							walletid={record?.id}
							type={record?.wallet_type}
							symbol={record?.wallet_symbol}
						/>
					</Text>
					<View
						style={{
							flexDirection: 'row',
							width: '100%',
							marginTop: 10,
						}}>
						<Radio.Group
							size="small"
							style={{ flex: 1 }}
							onChange={e => {
								setDeposit_withdraw(e.target.value)
							}}
							defaultValue={1}
							buttonStyle="solid"
							optionType="button">
							<Radio value={1}>입금</Radio>
							<Radio value={2}>출금</Radio>
							<Radio value={3}>동결</Radio>
							<Radio value={4}>동결해제</Radio>
						</Radio.Group>
						<Input
							size="small"
							style={{ width: '35%' }}
							value={amount}
							type="text"
							onChange={handleAmountChange}
							// onChange={e => {
							// 	setAmount(parseInt(e.target.value))
							// }}
						/>
						원
					</View>
					<Space.Compact
						size="small"
						style={{
							flexDirection: 'row',
							width: '100%',
							justifyContent: 'flex-start',
							marginTop: 10,
							borderTop: '1px solid #efefef',
							paddingTop: 10,
							whiteSpace: 'nowrap',
						}}>
						지급사유
						<Input
							size="small"
							style={{ width: '80%' }}
							value={text}
							onChange={e => {
								setText(e.target.value)
							}}
						/>
						<Button
							size="small"
							type="primary"
							onClick={() => {
								saveMemo()
							}}>
							저장
						</Button>
					</Space.Compact>

					<Space.Compact
						size="small"
						style={{ width: '100%', marginTop: 10 }}>
						<Select
							defaultValue={''}
							style={{ width: '80%' }}
							onChange={e => {
								setText(e.split('||')[1])
								setSelected(e.split('||')[0])
							}}
							size="small">
							<Select.Option value="">--사유목록--</Select.Option>
							{data?.result?.result?.list?.map((item, index) => {
								return (
									<Select.Option
										value={item?.id + '||' + item?.text}>
										{item?.text}
									</Select.Option>
								)
							})}
						</Select>
						<Button
							size="small"
							type="primary"
							danger
							onClick={() => {
								setText('')
								API.delete('/admin/cashmemo', token + '', {
									id: selected,
								}).then(res => {
									if (res.result.success) {
										message.success('삭제완료')
										refresh()
									} else {
										message.error(res.result.message)
									}
								})
							}}>
							삭제
						</Button>
					</Space.Compact>

					{deposit_withdraw === 1 && (
						<>
							<View
								style={{
									flexDirection: 'row',
									width: '100%',
									justifyContent: 'flex-start',
									marginTop: 10,
								}}>
								수동입금 출금제한 거래횟수
								<Input
									size="small"
									style={{ width: '35%' }}
									value={count}
									type="number"
									onChange={e => {
										setCount(parseInt(e.target.value))
									}}
								/>
								<Space.Compact size="small">
									<Button
										size="small"
										onClick={() => {
											setCount(0)
										}}>
										0
									</Button>
									<Button
										size="small"
										onClick={() => {
											setCount(5)
										}}>
										5
									</Button>
									<Button
										size="small"
										onClick={() => {
											setCount(10)
										}}>
										10
									</Button>
								</Space.Compact>
							</View>
							<View
								style={{
									background: '#efefef',
									borderRadius: 10,
									padding: 5,
									alignItems: 'flex-start',
									width: '100%',
									marginTop: 10,
								}}>
								<Text>
									* 해당 지급금은 횟수만큼 거래 후 출금가능합니다.
								</Text>
								<Text>* 0 입력시 바로 출금가능합니다.</Text>
							</View>
						</>
					)}
				</View>
			</Modal>
			<Button
				type="primary"
				danger
				block
				size="small"
				onClick={() => {
					setVisible(true)
				}}>
				수동관리
			</Button>
		</TagWrap>
	)
}

export default React.memo(Column_walletlist_action)
